// src/utils/constant.ts
var NameSpace = /* @__PURE__ */ ((NameSpace2) => {
  NameSpace2["CSS"] = "antd-resizable-header";
  return NameSpace2;
})(NameSpace || {});
var DefaultWidth = 120;

export { DefaultWidth, NameSpace };
